// Shared upload validation for the Ad Library — used by both the upload modal
// and the drag-and-drop drop zones so a dropped file is held to the exact same
// rules as one picked through the modal (mirrors services/contents uploadContent).

export const MAX_SIZE_MB = 500

// Accepted image formats — explicit allow-list (NOT `image/*`), so formats like
// WebP, GIF, BMP, HEIC, etc. are rejected. jpg and jpeg both report image/jpeg.
export const ACCEPTED_IMAGE_TYPES = ['image/png', 'image/jpeg']
export const ACCEPTED_IMAGE_EXTENSIONS = ['.png', '.jpg', '.jpeg']

// `accept` string for <input>/antd Dragger. Images are restricted to the
// allow-list above (the picker won't even show e.g. .webp); video stays broad
// and mp3 audio is allowed.
export const ACCEPT = [...ACCEPTED_IMAGE_TYPES, 'video/*', 'audio/mp3', '.mp3'].join(',')

export const isAllowedType = (file) => {
  const type = (file && file.type) || ''
  if (type.startsWith('image/')) return ACCEPTED_IMAGE_TYPES.includes(type)
  return type.startsWith('video/') || type === 'audio/mpeg'
}

export const isAllowedSize = (file) => file && file.size / 1024 / 1024 <= MAX_SIZE_MB

// Preview of a dynamic ad. Its own rules, distinct from the ad file's: the backend
// caps it at 15 MB and takes either an image or a video. A video preview is
// transcoded on AWS, so the content comes back with `preview_file: "pending"`
// until that finishes — see contentPreviewSource in services/contents.

export const PREVIEW_MAX_SIZE_MB = 15

// Images are an explicit allow-list, narrower than what the backend would take.
export const PREVIEW_ACCEPTED_IMAGE_TYPES = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/bmp',
  'image/gif',
  'image/webp'
]

// Video stays broad, like ACCEPT above: browsers report container types
// inconsistently (an .mkv often arrives with an empty type), so the backend is
// the authority on the exact list it takes.
export const PREVIEW_ACCEPT = [...PREVIEW_ACCEPTED_IMAGE_TYPES, 'video/*'].join(',')

export const isAllowedPreview = (file) => {
  if (!file || file.size / 1024 / 1024 > PREVIEW_MAX_SIZE_MB) return false
  const type = file.type || ''
  if (type.startsWith('image/')) return PREVIEW_ACCEPTED_IMAGE_TYPES.includes(type)
  return type.startsWith('video/')
}
